import "core-js/modules/es6.promise";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.reduce";
import _pickBy from "lodash/pickBy";
import _map from "lodash/map";
import ValidationError from './errors';

var formatter = function formatter(results) {
  return results.reduce(function (acc, input) {
    var name = input.name,
        errors = input.errors;
    acc.valid = acc.valid === false ? false : errors.length === 0;
    acc.validations[name] = Array.isArray(acc.validations[name]) ? acc.validations[name].concat(errors) : errors;
    return acc;
  }, {
    valid: true,
    validations: {}
  });
};
/**
 * @typedef {Object} ValidationResult
 * @property {Boolean} valid  Were all inputs valid?
 * @property {Object}  validations  Keys represent input name and values error messages
 * @example
 * // Example result with validation errors
 * {
 *   valid: true,
 *   validations: {
 *     validInput: [],
 *     validInputTwo: [],
 *   }
 * }
 *
 * @example
 * // Example result with validation errors
 * {
 *   valid: false,
 *   validations: {
 *     invalidInput: ['Must be something'],
 *     invalidInputTwo: ['Must contain uppercase letter', 'Must contain a symbol'],
 *     validInput: []
 *   }
 * }
 */

/**
 * @example
 * import validate from '@nerdwallet/home-app-lib/validate';
 *
 * validate(myInputs, data)
 *   .then(({ valid, validations }) => {
 *     console.log('Is valid?', valid);
 *     console.log('All inputs validated and error messages', validations);
 *     // do something
 *   });
 *
 * @function
 * @param  {Array} inputs  Constructed inputs
 * @param  {Object} data   To validate against
 * @return {Promise<ValidationResult>}       Resolves into an object with the input `name` as key and error messages as value
 */


export var validate = function validate(inputs, data) {
  return Promise.all(_map(inputs, function (input) {
    return input.validate(data).then(function (errors) {
      return {
        name: input.name,
        errors: errors
      };
    });
  })).then(formatter);
};
/**
 * Validation that rejects on error. Useful in express middleware
 * @example
 * import validate from '@nerdwallet/home-app-lib/validate';
 *
 * export function validate(req, res, next) {
 *   validate(myInputs, req.body)
 *    .then(next)
 *    .catch(next);
 * }
 *
 * @param  {Object|Array} inputs  Constructed Input defintions
 * @param  {Mixed} data   [description]
 * @return {Promise}    Will reject on error and resolve with no value on success
 */

export default (function (inputs, data) {
  return new Promise(function (resolve, reject) {
    return validate(inputs, data).then(function (_ref) {
      var valid = _ref.valid,
          validations = _ref.validations;

      if (!valid) {
        reject(new ValidationError('Invalid inputs', _pickBy(validations, function (input) {
          return input.length !== 0;
        })));
        return;
      }

      resolve();
    });
  });
});